import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  CircularProgress,
  Paper,
  Divider,
  Box,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import EnrolledStudents from './EnrolledStudents';
import Navbar from './Navbar';

const CourseStudentsPage = () => {
  const { id } = useParams();
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [course, setCourse] = useState(null);
  const token = localStorage.getItem('token');
  const [error, setError] = useState('');
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setOffset({ x, y });
    };
    const handleScroll = () => {
      setOffsetY(window.scrollY * 0.4);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Parallax background using color
  const backgroundBlockStyle = {
    position: 'fixed',
    top: `${-offsetY}px`,
    left: 0,
    width: '100%',
    height: '50vh',
    background: 'linear-gradient(to bottom, #4278f5, #e1f5fe)',
    zIndex: -1,
    transition: 'top 0.2s ease-out',
  };

  useEffect(() => {
    const fetchCourseAndStudents = async () => {
      try {
        const courseRes = await fetch(`http://196.216.9.34:5020/api/courses/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const courseData = await courseRes.json();
        if (!courseRes.ok) throw new Error(courseData.message || 'Failed to fetch course');
        setCourse(courseData);
      } catch (err) {
        setError(err.message);
      }

      try {
        const studentRes = await fetch(`http://196.216.9.34:5020/api/courses/${id}/students`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const studentData = await studentRes.json();
        if (!studentRes.ok) throw new Error(studentData.message || 'Failed to fetch students');
        setStudents(studentData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseAndStudents();
  }, [id]);

  if (loading) {
    return <CircularProgress sx={{ mt: 4, display: 'block', mx: 'auto' }} />;
  }

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh', overflow: 'hidden' }}>
      {/* Sky blue background block with parallax effect */}
      <Box style={backgroundBlockStyle} />

      {/* Navbar */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Navbar />
      </Box>

      {/* Content */}
      <Container maxWidth="md" sx={{ py: 6, position: 'relative', zIndex: 2 }}>
        <Paper
          elevation={6}
          sx={{
            p: 4,
            borderRadius: 4,
            background: 'rgba(255, 255, 255, 0.85)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            textAlign: 'center',
            mb: 5,
            mt: 12,
          }}
        >
          <Typography variant="h3" fontWeight="bold" sx={{ mb: 1 }}>
            {course?.title || 'Course Title'}
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" color="text.secondary">
            {course?.description || 'Course description not available.'}
          </Typography>
        </Paper>

        <EnrolledStudents courseId={id} />
      </Container>
    </Box>
  );
};

export default CourseStudentsPage;
